import { connect } from "react-redux";
import { Form } from "formik";
import moment from "moment-timezone";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import * as yup from "yup";

import { getUsernameFromToken } from "@/utils/authToken";
import { providerRequests } from "@/api/(requests)/provider";
import { sharedRequests } from "@/api/(requests)/shared";

import AssociatedFiles from "../../../components/Provider/PatientView/AssociatedFiles";
import Button from "../../../components/UI/Button";
import CardHeading from "../../../components/UI/Headings/CardHeading";
import CardSecondary from "../../../components/UI/Card/CardSecondary";
import CommonUserDetails from "../../../components/Provider/PatientView/CommonUserDetails";
import { CustomForm } from "../../../component-library/CustomForm";
import FormikInput from "../../../components/UI/FormikInput";
import { getAutomationDataAttr } from "../../../utils/automationUtils";
import images from "../../../utils/images";
import MenuPopUp from "../../../components/UI/MenuPopUp";
import { OutreachEntries } from "../../../components/Provider/PatientView/MemberProfile/Outreach";
import ProgressSlider from "../../../components/UI/ProgressSlider";
import { viewReferralAssociatedFile, getReferralAssociatedFiles } from "../../../utils/fileUtil";

import PatientReferralInfo from "./PatientReferralInfo";

class ReferralView extends Component {
  state = {
    files: [],
    markerData: [
      {
        caption: "PCP Referred",
        status: "done",
      },
      {
        caption: "Initial Contact",
        status: "active",
      },
      {
        caption: "Screening",
        status: "default",
      },
    ],
    newOutreach: {
      contacted: false,
      note: "",
    },
    outreachCount: 0,
    pcpName: "",
    practiceName: "",
    referral: {
      address: {
        city: "",
        state: "",
        street: "",
        zip_code: "",
      },
      contacted: false,
      contactedDate: "",
      dob: "",
      email: "",
      emergency_contact_number: "",
      emergency_contact_person: "",
      first_name: "",
      gender: "male",
      last_name: "",
      mobile: "",
      outreach: {},
      primary_insurance: {
        card_back: "",
        card_front: "",
        carrier: "",
        member_id: "",
        policy_dob: "",
        state: "",
      },
      referral_status: "ACTIVE",
      referral_status_reason: "",
      referralCode: "",
      secondary_insurance: {
        card_back: "",
        card_front: "",
        carrier: "",
        member_id: "",
        policy_dob: "",
        state: "",
      },
      urgent_patient: false,
    },
    showOutreachPopup: false,
    showStatusPopup: false,
  };

  componentDidMount = async () => {
    try {
      await this.getReferral();
      if (this.state.referral.pcp_practice_id) {
        await this.getPractice();
      }
      if (this.state.referral.pcp_practice_id && this.state.referral.pcp_id) {
        await this.getProvider();
      }
      await this.getAssociatedFiles();
    } catch (e) {
      console.log(e);
    }
  };

  getPractice = async () => {
    let searchParams = { practiceId: this.state.referral.pcp_practice_id };
    let cleanResponse = await sharedRequests.fetch_practice({ searchParams });

    this.setState({
      practiceName: cleanResponse.name,
    });
  };

  getAssociatedFiles = async () => {
    const files = await getReferralAssociatedFiles(this.props.match.params.referralCode);

    this.setState({ files });
  };

  getProvider = async () => {
    let searchParams = {
      practiceId: this.state.referral.pcp_practice_id,
      providerId: this.state.referral.pcp_id,
    };
    let cleanResponse = await sharedRequests.fetch_practice_provider({ searchParams });

    this.setState({
      pcpName: cleanResponse.name,
    });
  };

  getReferral = async () => {
    let searchParams = { referralCode: this.props.match.params.referralCode };
    let response = await sharedRequests.fetch_referral({ searchParams });
    let newState = { ...this.state, referral: response };

    if (response.outreach) {
      newState["outreachCount"] = Object.keys(response.outreach).length;
      let entry = Object.entries(response.outreach).find((entry) => entry[1].contacted);

      if (entry) {
        newState["contacted"] = true;
        let utcDate = moment.utc(entry[0]);
        let { am_pm, date, time } = this.getDateTimeParts(utcDate);

        newState["contactedDate"] = this.getDateStr(date, time, am_pm);
        newState["markerData"] = [...this.state.markerData];
        newState["markerData"][1].status = "done";
        newState["markerData"][2].status = "active";
      }
    }
    this.setState(newState);
  };

  submitStatusHandler = async (formData, actions) => {
    actions.setSubmitting(false);
    try {
      let data = { ...formData };

      data["referralCode"] = this.state.referral.referralCode;
      data["referral_status"] = "INACTIVE";
      let response = await sharedRequests.update_referral({ data });

      this.setState({ referral: response, showStatusPopup: false });
    } catch (e) {
      console.log(e);
    }
  };

  submitOutreachHandler = async (formData, actions) => {
    actions.setSubmitting(false);
    try {
      let outreach = { ...this.state.referral.outreach };
      const dateStr = moment.utc().format();

      outreach[dateStr] = {
        contacted: this.state.newOutreach.contacted,
        created_by_name: this.props.profile.name,
        created_by_username: getUsernameFromToken(),
        credential: this.props?.profile?.cp_credentials ?? null,
        note: formData["note"],
      };
      let data = {
        contacted: this.state.newOutreach.contacted,
        contactedDate: this.state.newOutreach.contacted ? dateStr : null,
        outreach: outreach,
        referralCode: this.state.referral.referralCode,
      };
      let response = await sharedRequests.update_referral({ data });
      const newState = {
        newOutreach: {
          contacted: false,
          note: "",
        },
        outreachCount: this.state.outreachCount + 1,
        referral: response,
        showOutreachPopup: false,
      };

      if (data["contacted"]) {
        newState["markerData"] = [...this.state.markerData];
        newState["markerData"][1].status = "done";
        newState["markerData"][2].status = "active";
      }
      this.setState(newState);
    } catch (e) {
      console.log(e);
    }
  };

  getDateStr(date, time, am_pm) {
    return (
      date.substring(0, 2) +
      "/" +
      date.substring(2, 4) +
      "/" +
      date.substring(4, 8) +
      " " +
      time.substring(0, 2) +
      ":" +
      time.substring(2, 4) +
      " " +
      am_pm
    );
  }

  getDateTimeParts(dateTime) {
    let date = dateTime.format("MM/DD/YYYY").replace(/\//g, "");
    let time = dateTime.format("hh:mm").replace(/:/g, "");
    let am_pm = dateTime.format("a");

    return { am_pm, date, time };
  }

  radioInputHandler = (name, option) => {
    let newOutreach = { ...this.state.newOutreach };

    newOutreach[name] = option.value;
    this.setState({ newOutreach });
  };

  renderOutreachForm = (formikProps) => {
    return (
      <Form className="py-4">
        <div className="mx-auto">
          <div className="container px-0">
            <div className="row">
              {[
                {
                  elementConfig: {
                    label: "Contact Attempt",
                    options: [
                      { display: "Successfully Contacted", value: true },
                      { display: "Contact Unsuccessful", value: false },
                    ],
                  },
                  elementType: "radio",
                  name: "contacted",
                  onchange: this.radioInputHandler,
                },
                {
                  elementConfig: {
                    label: "Notes",
                    type: "textarea",
                  },
                  elementType: "textarea",
                  name: "note",
                },
              ].map((formEl) => {
                return (
                  <div className="col-12" key={formEl.name}>
                    <FormikInput
                      errors={formikProps.errors}
                      formEl={formEl}
                      touched={formikProps.touched}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="d-lg-flex d-block text-center justify-content-lg-start tw:justify-center">
          <Button
            className="Btn Btn--otl-pri Btn-sm mr-lg-3 mb-3 mb-lg-0"
            onClick={() => this.setState({ showOutreachPopup: false })}
            type="button"
          >
            Cancel
          </Button>
          <Button className="Btn Btn--pri Btn-sm" type="submit">
            Add
          </Button>
        </div>
      </Form>
    );
  };

  setHeader = (details) => {
    let status =
      details && "INACTIVE" !== details.referral_status ? (
        <div className="PatientProfile__ActiveStatus d-inline fs-12">{details.referral_status}</div>
      ) : (
        <div className="PatientProfile__InactiveStatus d-inline fs-12">
          {details.referral_status}
        </div>
      );

    return (
      <div>
        <CardHeading
          className="fs-18 fs-lg-22 mb-0 mt-2 text-break"
          text={details.first_name + " " + details.last_name}
        />
        {status}
      </div>
    );
  };

  resendReferral = () => {
    providerRequests
      .resend_referral_code({
        context: { showLoader: false },
        searchParams: { referralCode: this.state.referral.referralCode },
      })
      .then((cleanResponse) => {
        this.setState({
          menuData: null,
          showResendReferralPopup: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  hideResendReferralPopup = () => {
    this.setState({
      showResendReferralPopup: false,
    });
  };

  showStatusPopup = () => {
    this.setState({
      menuData: null,
      showStatusPopup: true,
    });
  };

  menuClickHandler = (e) => {
    let rect = e.target.getBoundingClientRect();
    let popUpLeft = rect.left - 145;
    let popUpTop = rect.top + 40;

    this.setState((ps) => {
      if (!ps.menuData) {
        return {
          menuData: {
            actions: {
              changeStatus: {
                caption: "Change Status",
                handler: this.showStatusPopup,
              },
              resendReferral: {
                caption: "Resend Referral",
                handler: this.resendReferral,
              },
            },
            position: { left: popUpLeft, top: popUpTop },
          },
        };
      }

      return {
        menuData: null,
      };
    });
  };

  render() {
    return (
      <div className="row container mx-auto" {...getAutomationDataAttr("ReferralPage")}>
        {this.state.showResendReferralPopup && (
          <div className="admitPatientPopUp position-fixed d-flex align-items-center tw:justify-center">
            <div
              className="row position-absolute px-4 m-2 text-center"
              style={{
                backgroundColor: "white",
                borderRadius: 3,
                maxWidth: "300px",
                padding: 20,
              }}
            >
              <div className="col-12">
                <img alt="success" className="mb-4" src={images("./common/successCheck.svg")} />
              </div>
              <div className="col-12">
                <h5>Referral Sent</h5>
              </div>
              <div className="col-12">
                <p data-private>
                  Referral sent to {this.state.referral.first_name} {this.state.referral.last_name}{" "}
                  successfully!
                </p>
              </div>
              <div className="col-12">
                <Button className="Btn Btn--pri" onClick={this.hideResendReferralPopup}>
                  OK
                </Button>
              </div>
            </div>
          </div>
        )}
        {this.state.showStatusPopup && (
          <div className="admitPatientPopUp position-fixed d-flex align-items-center tw:justify-center">
            <div
              className="row position-absolute px-4 m-2"
              style={{
                backgroundColor: "white",
                borderRadius: 3,
                maxWidth: "500px",
              }}
            >
              <CustomForm
                initialValues={{
                  referral_status_reason: "",
                  referral_status_reason_context: "",
                }}
                onSubmit={this.submitStatusHandler}
                render={(formikProps) =>
                  renderStatusForm(formikProps, () => {
                    this.setState({
                      showStatusPopup: false,
                    });
                  })
                }
                validationSchema={yup.object().shape({
                  referral_status_reason: yup.string().required("Reason is required"),
                })}
              />
            </div>
          </div>
        )}
        <div className="fs-16 my-3 py-2">
          <div
            className="PatientProfile-back-link BackLink cursor"
            onClick={this.props.history.goBack}
          >
            <img className="img-fluid" src={images("./common/solidBckBtn.svg")} />
            <p className="d-inline ml-2">Back to Patients</p>
          </div>
        </div>
        <div className="w-100 mx-auto mt-4 mb-5 my-lg-5">
          <ProgressSlider markerData={this.state.markerData} />
        </div>
        <div className="col-lg-4 col-12">
          <CommonUserDetails
            details={this.state.referral}
            getReferral={this.getReferral}
            isReferral
          >
            <div className="d-flex justify-content-between align-items-center pl-3 py-4">
              <div className="d-flex align-items-start">
                <img
                  alt="Profile Picture"
                  className="img-fluid mr-3"
                  src={images("./common/avatar.png")}
                  width="40"
                />
                <div className="patientProfile__name d-inline-block">
                  {this.state.referral && this.setHeader(this.state.referral)}
                </div>
              </div>
              <div
                className="PatientStatusPopUp__three-dots-menu cursor p-2"
                onClick={(e) => {
                  this.menuClickHandler(e);
                }}
              >
                <img alt="Menu" className="img-fluid" src={images("./common/menuThreeDots.svg")} />
              </div>
              {this.state.menuData && (
                <MenuPopUp
                  actions={this.state.menuData.actions}
                  position={this.state.menuData.position}
                />
              )}
            </div>
          </CommonUserDetails>
          <PatientReferralInfo
            pcpName={this.state.pcpName}
            practiceName={this.state.practiceName}
            referralCode={this.state.referral.referralCode}
            referralCreatedDate={this.state.referral.created_date}
          />
          {this.state.referral && (
            <AssociatedFiles
              fileList={this.state.files}
              getFile={(key) => viewReferralAssociatedFile(this.state.referral.referralCode, key)}
              viewAllLink={`/app/referral/${this.state.referral.referralCode}/file`}
            />
          )}
        </div>
        <div className="col-lg-8 col-12 my-4">
          <div className="m-2 p-1">
            <CardSecondary className="PatientProfile__CreatePlan-wpr PatientProfile__CardBetweenMargin mx-xl-auto py-4 d-xl-flex d-block justify-content-between align-items-center px-3 px-xl-4">
              <div className="d-flex align-items-center">
                <img
                  alt="mail"
                  className="PatientProfile__90DaysPlan img-fluid"
                  src={images("./common/purple-white-mail.svg")}
                  width="39px"
                />
                <CardHeading
                  className="text-white d-lg-inline-block ml-2 pl-2 mr-0 mr-lg-5 fs-16"
                  text="Warm Contact"
                />
              </div>
              <div className="ml-auto">
                <div className="d-block text-right">
                  {!this.state.showOutreachPopup && (
                    <Button
                      className="Btn Btn--pri Btn-sm"
                      onClick={() => this.setState({ showOutreachPopup: true })}
                    >
                      Add Warm Contact Attempt
                    </Button>
                  )}
                </div>
              </div>
            </CardSecondary>
            {this.state.showOutreachPopup && (
              <CardSecondary style={{ backgroundColor: "white", borderRadius: 3, padding: 20 }}>
                <CustomForm
                  initialValues={this.state.newOutreach}
                  onSubmit={this.submitOutreachHandler}
                  render={this.renderOutreachForm}
                  validationSchema={undefined}
                />
              </CardSecondary>
            )}
          </div>
          {this.state.referral.outreach && (
            <OutreachEntries outreach={this.state.referral.outreach} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
    timezone: state.auth.timezone,
  };
};

export default connect(mapStateToProps)(withRouter(ReferralView));

export const renderStatusForm = (formikProps, hidePopUp, patientName) => {
  return (
    <Form className="py-4">
      <div className="mx-auto">
        <div className="container px-0">
          <label className="Label pb-2" data-private>
            Archive: {patientName}
          </label>
          <div className="row">
            {[
              {
                elementConfig: {
                  label: "Reason",
                  options: [
                    {
                      display: "Patient decline to proceed",
                      value: "Patient decline to proceed",
                    },
                    {
                      display: "Patient unresponsive",
                      value: "Patient unresponsive",
                    },
                    {
                      display: "Patient is not a fit for aptihealth",
                      value: "Patient is not a fit for aptihealth",
                    },
                  ],
                },
                elementType: "select",
                name: "referral_status_reason",
              },
              {
                elementConfig: {
                  label: "Reason Context",
                  type: "textArea",
                },
                elementType: "textarea",
                name: "referral_status_reason_context",
              },
            ].map((formEl) => {
              return (
                <div className="col-12" key={formEl.name}>
                  <FormikInput
                    errors={formikProps.errors}
                    formEl={formEl}
                    touched={formikProps.touched}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="d-lg-flex d-block text-center justify-content-lg-end tw:justify-center">
        <Button
          className="Btn Btn--otl-pri Btn-sm mr-lg-3 mb-3 mb-lg-0"
          onClick={hidePopUp}
          type="button"
        >
          Cancel
        </Button>
        <Button className="Btn Btn--pri Btn-sm" type="submit">
          Save
        </Button>
      </div>
    </Form>
  );
};
